import {
  Alert,
  Box,
  Button,
  Chip,
  Container,
  Dialog,
  DialogActions,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  LinearProgress,
  Paper,
  Radio,
  RadioGroup,
  Snackbar,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  InputAdornment,
  ToggleButton,
  ToggleButtonGroup,
  Badge,
  Tooltip,
  Popover,
  Autocomplete,
  Switch,
  FormGroup,
  DialogContent,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import SettingsEthernetIcon from '@mui/icons-material/SettingsEthernet';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import ViewListIcon from '@mui/icons-material/ViewList';
import FilterListIcon from '@mui/icons-material/FilterList';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import React, { useEffect, useState } from 'react';
import Slide from '@mui/material/Slide';
import styled from '@emotion/styled';
import axios from '../../axios';
import './animation.css';

const HeaderPaper = styled(Paper)(({ theme }) => ({
  background: 'linear-gradient(135deg, #134e5e 0%, #71b280 100%)',
  borderRadius: '12px',
  padding: '16px 24px',
  marginBottom: '16px',
  boxShadow: '0 4px 20px rgba(19, 78, 94, 0.3)',
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  color: '#fff',
  fontWeight: 700,
  textAlign: 'left',
  backgroundColor: '#1a3a4a',
  padding: '8px 12px',
  whiteSpace: 'nowrap',
  fontSize: '0.75rem',
  letterSpacing: '0.03em',
  borderBottom: '2px solid rgba(255,255,255,0.1)',
  position: 'sticky',
  top: 0,
  zIndex: 10,
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: 'rgba(0, 0, 0, 0.02)',
  },
  '&:hover': {
    backgroundColor: 'rgba(25, 118, 210, 0.04)',
    transition: 'background-color 0.2s ease',
  },
}));

const StickyTableContainer = styled(TableContainer)(({ theme }) => ({
  maxHeight: '70vh',
  '& .MuiTableHead-root': {
    position: 'sticky',
    top: 0,
    zIndex: 10,
  },
}));

const token =
  'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ';
const emptyForm = {
  ProfileCode: '',
  ProfileName: '',
  SMTPHost: '',
  SMTPPort: 587,
  IsSecure: 'N',
  SMTPUserName: '',
  SMTPPassword: '',
  FromEmail: '',
  IsActive: 'Y',
};

const SMTPProfileMaster = () => {
  const [profiles, setProfiles] = useState([]);
  const [form, setForm] = useState(emptyForm);
  const [editingId, setEditingId] = useState(null);
  const [open, setOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [alert, setAlert] = useState({ open: false, severity: 'success', message: '' });
  const [viewMode, setViewMode] = useState('table');
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const [activeFilter, setActiveFilter] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const requestConfig = { headers: { Authorization: token, 'Content-Type': 'application/json' } };

  const loadProfiles = async () => {
    setLoading(true);
    try {
      const response = await axios.instance.get('/GetAllSMTPProfiles', requestConfig);
      setProfiles(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      setAlert({ open: true, severity: 'error', message: 'Failed to load SMTP profiles.' });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadProfiles();
  }, []);

  const updateField = (event) => {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
  };

  const openAdd = () => {
    setEditingId(null);
    setForm(emptyForm);
    setOpen(true);
    setShowPassword(false);
  };

  const openEdit = (profile) => {
    setEditingId(profile.SMTPProfileID);
    setForm({
      ProfileCode: profile.ProfileCode || '',
      ProfileName: profile.ProfileName || '',
      SMTPHost: profile.SMTPHost || '',
      SMTPPort: profile.SMTPPort || 587,
      IsSecure: profile.IsSecure || 'N',
      SMTPUserName: profile.SMTPUserName || '',
      SMTPPassword: profile.SMTPPassword || '',
      FromEmail: profile.FromEmail || '',
      IsActive: profile.IsActive || 'Y',
    });
    setOpen(true);
    setShowPassword(false);
  };

  const saveProfile = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    const payload = { ...form, SMTPPort: Number(form.SMTPPort), CreatedBy: 5, ModifyedBy: 5 };
    try {
      if (editingId) {
        await axios.instance.put(`/UpdateSMTPProfile/${editingId}`, payload, requestConfig);
      } else {
        await axios.instance.post('/InsertSMTPProfile', payload, requestConfig);
      }
      setOpen(false);
      await loadProfiles();
      setAlert({
        open: true,
        severity: 'success',
        message: `SMTP profile ${editingId ? 'updated' : 'saved'} successfully.`,
      });
    } catch (error) {
      setAlert({ open: true, severity: 'error', message: error.response?.data || 'Failed to save SMTP profile.' });
    } finally {
      setIsSubmitting(false);
    }
  };

  const deleteProfile = async () => {
    try {
      await axios.instance.delete(`/DeleteSMTPProfile/${deleteId}`, requestConfig);
      setDeleteId(null);
      await loadProfiles();
      setAlert({ open: true, severity: 'success', message: 'SMTP profile deleted successfully.' });
    } catch (error) {
      setAlert({ open: true, severity: 'error', message: 'Failed to delete SMTP profile.' });
    }
  };

  const handleFilterOpen = (event) => {
    setFilterAnchorEl(event.currentTarget);
  };

  const handleFilterClose = () => {
    setFilterAnchorEl(null);
  };

  const getFilteredData = () => {
    let filtered = profiles;
    if (searchTerm) {
      const searchLower = searchTerm.toLowerCase();
      filtered = filtered.filter((item) =>
        Object.values(item).some((value) => typeof value === 'string' && value.toLowerCase().includes(searchLower))
      );
    }
    if (activeFilter && activeFilter.value !== 'all') {
      filtered = filtered.filter((item) => item.IsActive === activeFilter.value);
    }
    return filtered;
  };

  const filteredData = getFilteredData();

  const clearAllFilters = () => {
    setActiveFilter(null);
    setSearchTerm('');
    handleFilterClose();
  };

  const getActiveFilterCount = () => {
    let count = 0;
    if (activeFilter && activeFilter.value !== 'all') {
      count += 1;
    }
    if (searchTerm) {
      count += 1;
    }
    return count;
  };

  const statusOptions = [
    { label: 'All Status', value: 'all' },
    { label: 'Active', value: 'Y' },
    { label: 'Inactive', value: 'N' },
  ];

  // Render Table View
  const renderTableView = () => (
    <Paper sx={{ borderRadius: 3, overflow: 'hidden', border: '1px solid #e8ecf0' }}>
      <StickyTableContainer>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <StyledTableCell align="center" sx={{ width: 40 }}>
                #
              </StyledTableCell>
              <StyledTableCell>Profile</StyledTableCell>
              <StyledTableCell>SMTP Host</StyledTableCell>
              <StyledTableCell align="center" sx={{ width: 60 }}>
                Port
              </StyledTableCell>
              <StyledTableCell>Username</StyledTableCell>
              <StyledTableCell>From Email</StyledTableCell>
              <StyledTableCell align="center" sx={{ width: 70 }}>
                Secure
              </StyledTableCell>
              <StyledTableCell align="center" sx={{ width: 80 }}>
                Status
              </StyledTableCell>
              <StyledTableCell align="center" sx={{ width: 90 }}>
                Actions
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredData.map((profile, index) => (
              <StyledTableRow key={profile.SMTPProfileID} sx={{ '&:last-child td': { borderBottom: 0 } }}>
                <TableCell align="center" sx={{ fontSize: '0.75rem', fontWeight: 500, py: 1 }}>
                  {index + 1}
                </TableCell>
                <TableCell sx={{ py: 1 }}>
                  <Stack direction="column" spacing={0.5}>
                    <Typography variant="body2" fontWeight={700} sx={{ fontSize: '0.8rem' }}>
                      {profile.ProfileCode}
                    </Typography>
                    <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.65rem' }}>
                      {profile.ProfileName}
                    </Typography>
                  </Stack>
                </TableCell>
                <TableCell sx={{ py: 1 }}>
                  <Typography variant="body2" sx={{ fontSize: '0.75rem' }}>
                    {profile.SMTPHost}
                  </Typography>
                </TableCell>
                <TableCell align="center" sx={{ py: 1 }}>
                  <Chip
                    label={profile.SMTPPort}
                    size="small"
                    variant="outlined"
                    sx={{ fontWeight: 500, fontSize: '0.65rem', height: 20 }}
                  />
                </TableCell>
                <TableCell sx={{ py: 1 }}>
                  <Typography variant="body2" sx={{ fontSize: '0.75rem' }}>
                    {profile.SMTPUserName}
                  </Typography>
                </TableCell>
                <TableCell sx={{ py: 1 }}>
                  <Typography variant="body2" sx={{ fontSize: '0.75rem' }}>
                    {profile.FromEmail}
                  </Typography>
                </TableCell>
                <TableCell align="center" sx={{ py: 1 }}>
                  <Chip
                    label={profile.IsSecure === 'Y' ? 'Yes' : 'No'}
                    color={profile.IsSecure === 'Y' ? 'info' : 'default'}
                    size="small"
                    sx={{ fontWeight: 500, fontSize: '0.6rem', height: 20 }}
                  />
                </TableCell>
                <TableCell align="center" sx={{ py: 1 }}>
                  <Chip
                    icon={
                      profile.IsActive === 'Y' ? (
                        <CheckCircleOutlineIcon sx={{ fontSize: 14 }} />
                      ) : (
                        <HighlightOffIcon sx={{ fontSize: 14 }} />
                      )
                    }
                    label={profile.IsActive === 'Y' ? 'Active' : 'Inactive'}
                    color={profile.IsActive === 'Y' ? 'success' : 'error'}
                    size="small"
                    sx={{ fontWeight: 600, height: 22, fontSize: '0.65rem' }}
                  />
                </TableCell>
                <TableCell align="center" sx={{ py: 1 }}>
                  <Tooltip title="Edit">
                    <IconButton size="small" onClick={() => openEdit(profile)} sx={{ color: 'primary.main', p: 0.5 }}>
                      <EditIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Delete">
                    <IconButton
                      size="small"
                      onClick={() => setDeleteId(profile.SMTPProfileID)}
                      sx={{ color: 'error.main', p: 0.5 }}
                    >
                      <DeleteForeverIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </StickyTableContainer>
    </Paper>
  );

  return (
    <>
      <style>{`
        /* Sticky Dialog Styles */
        .sticky-dialog .MuiDialog-paper {
          display: flex;
          flex-direction: column;
          max-height: 95vh;
        }
        .sticky-dialog .MuiDialogContent-root {
          flex: 1 1 auto;
          overflow-y: auto;
          padding: 24px;
        }
        .sticky-dialog .MuiDialogActions-root {
          flex-shrink: 0;
        }
        .sticky-dialog .MuiDialogTitle-root {
          flex-shrink: 0;
        }
      `}</style>

      <Snackbar
        open={alert.open}
        autoHideDuration={3500}
        onClose={() => setAlert((current) => ({ ...current, open: false }))}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        TransitionComponent={Slide}
      >
        <Alert severity={alert.severity} variant="filled" sx={{ width: '100%', borderRadius: 2 }}>
          {alert.message}
        </Alert>
      </Snackbar>

      <Container maxWidth="xl" sx={{ pt: 3, pb: 4 }}>
        <HeaderPaper elevation={0}>
          <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" alignItems="center">
            <Stack direction="row" alignItems="center" spacing={1}>
              <SettingsEthernetIcon sx={{ color: 'white' }} />
              <Typography variant="h6" fontWeight={700} color="white" sx={{ letterSpacing: '0.02em' }}>
                SMTP Profile Master
              </Typography>
            </Stack>
            <Typography variant="caption" color="rgba(255,255,255,0.7)">
              Total: {profiles.length} profiles
            </Typography>
          </Stack>
        </HeaderPaper>

        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={2}
          alignItems={{ xs: 'stretch', md: 'center' }}
          sx={{ mb: 3 }}
        >
          <TextField
            placeholder="Search profiles..."
            size="small"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{ flex: 1, minWidth: { md: 200 } }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
              endAdornment: searchTerm && (
                <InputAdornment position="end">
                  <IconButton size="small" onClick={() => setSearchTerm('')}>
                    <ClearIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <Stack direction="row" spacing={1} alignItems="center">
            <Badge badgeContent={getActiveFilterCount()} color="primary" invisible={getActiveFilterCount() === 0}>
              <Button
                variant="outlined"
                startIcon={<FilterListIcon />}
                onClick={handleFilterOpen}
                size="small"
                sx={{ borderRadius: 2 }}
              >
                Filters
              </Button>
            </Badge>

            <ToggleButtonGroup
              value={viewMode}
              exclusive
              onChange={(e, val) => val && setViewMode(val)}
              size="small"
              sx={{ '& .MuiToggleButton-root': { px: 1.5 } }}
            >
              <ToggleButton value="table">
                <ViewListIcon fontSize="small" />
              </ToggleButton>
            </ToggleButtonGroup>

            <Button
              variant="contained"
              startIcon={<PlaylistAddIcon />}
              onClick={openAdd}
              sx={{ borderRadius: 2, boxShadow: 2 }}
            >
              Add Profile
            </Button>
          </Stack>
        </Stack>

        <Popover
          open={Boolean(filterAnchorEl)}
          anchorEl={filterAnchorEl}
          onClose={handleFilterClose}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          PaperProps={{ sx: { maxWidth: 280, width: '100%', p: 2 } }}
        >
          <Typography variant="subtitle2" fontWeight={600} gutterBottom>
            Filter Profiles
          </Typography>
          <Stack spacing={2} sx={{ mt: 1 }}>
            <Autocomplete
              size="small"
              options={statusOptions}
              getOptionLabel={(option) => option.label}
              value={activeFilter}
              onChange={(e, newValue) => setActiveFilter(newValue)}
              renderInput={(params) => <TextField {...params} label="Status" size="small" />}
            />
            <Stack direction="row" spacing={1}>
              <Button variant="contained" size="small" fullWidth onClick={clearAllFilters} startIcon={<ClearIcon />}>
                Clear All
              </Button>
              <Button variant="outlined" size="small" fullWidth onClick={handleFilterClose}>
                Apply
              </Button>
            </Stack>
          </Stack>
        </Popover>

        {filteredData.length > 0 && (
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
            Showing {filteredData.length} profile{filteredData.length !== 1 ? 's' : ''}
          </Typography>
        )}

        {filteredData.length === 0 ? (
          <Paper sx={{ textAlign: 'center', py: 6, borderRadius: 3 }}>
            <Typography variant="h6" color="text.secondary">
              No profiles found
            </Typography>
            <Typography variant="body2" color="text.disabled">
              Try adjusting your filters or add a new profile
            </Typography>
          </Paper>
        ) : (
          renderTableView()
        )}
      </Container>

      {/* Add/Edit Dialog - Redesigned with Sticky Header & Footer */}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="md"
        fullScreen={false}
        className="sticky-dialog"
        PaperProps={{
          sx: {
            borderRadius: '16px',
            maxHeight: '90vh',
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            maxWidth: '640px',
          },
        }}
      >
        <form onSubmit={saveProfile} style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          {/* Sticky Header */}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '16px 24px',
              borderBottom: '1px solid #e8ecf0',
              backgroundColor: '#fafbfc',
              flexShrink: 0,
              position: 'sticky',
              top: 0,
              zIndex: 10,
              borderRadius: '16px 16px 0 0',
            }}
          >
            <Stack direction="row" alignItems="center" spacing={1.5}>
              <SettingsEthernetIcon sx={{ color: 'primary.main' }} />
              <Typography variant="h6" fontWeight={600}>
                {editingId ? 'Edit SMTP Profile' : 'Add SMTP Profile'}
              </Typography>
            </Stack>
            <IconButton size="small" onClick={() => setOpen(false)}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>

          {/* Scrollable Content */}
          <DialogContent
            sx={{
              p: 3,
              overflow: 'auto',
              flex: '1 1 auto',
              '&:first-of-type': { pt: 3 },
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  label="Profile Code"
                  name="ProfileCode"
                  value={form.ProfileCode}
                  onChange={updateField}
                  fullWidth
                  size="small"
                  disabled={Boolean(editingId)}
                  helperText={editingId ? 'Profile Code cannot be changed' : 'Example: HR or SALES'}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SettingsEthernetIcon fontSize="small" color="action" />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  label="Profile Name"
                  name="ProfileName"
                  value={form.ProfileName}
                  onChange={updateField}
                  fullWidth
                  size="small"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  label="SMTP Host"
                  name="SMTPHost"
                  value={form.SMTPHost}
                  onChange={updateField}
                  fullWidth
                  size="small"
                  placeholder="smtp.gmail.com"
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  required
                  type="number"
                  label="SMTP Port"
                  name="SMTPPort"
                  value={form.SMTPPort}
                  onChange={updateField}
                  fullWidth
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={8}>
                <TextField
                  required
                  label="SMTP Username"
                  name="SMTPUserName"
                  value={form.SMTPUserName}
                  onChange={updateField}
                  fullWidth
                  size="small"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required={!editingId}
                  type={showPassword ? 'text' : 'password'}
                  label="SMTP Password"
                  name="SMTPPassword"
                  value={form.SMTPPassword}
                  onChange={updateField}
                  fullWidth
                  size="small"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <IconButton size="small" onClick={() => setShowPassword(!showPassword)} edge="start">
                          {showPassword ? <VisibilityOffIcon fontSize="small" /> : <VisibilityIcon fontSize="small" />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  type="email"
                  label="From Email"
                  name="FromEmail"
                  value={form.FromEmail}
                  onChange={updateField}
                  fullWidth
                  size="small"
                  placeholder="noreply@example.com"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth component="fieldset" size="small">
                  <FormLabel component="legend">Secure TLS</FormLabel>
                  <RadioGroup row name="IsSecure" value={form.IsSecure} onChange={updateField}>
                    <FormControlLabel value="Y" control={<Radio size="small" />} label="Yes" />
                    <FormControlLabel value="N" control={<Radio size="small" />} label="No" />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>
          </DialogContent>

          {/* Sticky Footer with Switch and Buttons */}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: 2,
              padding: '12px 24px',
              borderTop: '1px solid #e8ecf0',
              backgroundColor: '#fafbfc',
              flexShrink: 0,
              position: 'sticky',
              bottom: 0,
              zIndex: 10,
              borderRadius: '0 0 16px 16px',
              flexWrap: 'wrap',
            }}
          >
            {/* Left side - Status Switch */}
            <Stack direction="row" spacing={2} alignItems="center">
              <FormGroup row>
                <FormControlLabel
                  control={
                    <Switch
                      checked={form.IsActive === 'Y'}
                      onChange={(e) => {
                        const newValue = e.target.checked ? 'Y' : 'N';
                        setForm((current) => ({ ...current, IsActive: newValue }));
                      }}
                      color="success"
                      size="small"
                    />
                  }
                  label={
                    <Typography variant="body2" fontWeight={500}>
                      {form.IsActive === 'Y' ? 'Active' : 'Inactive'}
                    </Typography>
                  }
                />
              </FormGroup>
            </Stack>

            {/* Right side - Action Buttons */}
            <Stack direction="row" spacing={1}>
              <Button variant="outlined" onClick={() => setOpen(false)} size="medium">
                Cancel
              </Button>
              <Button
                type="submit"
                variant="contained"
                size="medium"
                disabled={isSubmitting}
                startIcon={editingId ? <EditIcon /> : <PlaylistAddIcon />}
              >
                {isSubmitting ? 'Saving...' : editingId ? 'Update Profile' : 'Save Profile'}
              </Button>
            </Stack>
          </Box>
        </form>
      </Dialog>

      {/* Delete Dialog */}
      <Dialog open={Boolean(deleteId)} onClose={() => setDeleteId(null)} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ fontWeight: 600 }}>Delete this SMTP profile?</DialogTitle>
        <DialogActions sx={{ px: 3, pb: 3 }}>
          <Button variant="outlined" onClick={() => setDeleteId(null)}>
            Cancel
          </Button>
          <Button color="error" variant="contained" onClick={deleteProfile}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* Loader */}
      {loading && (
        <Dialog open={loading} fullWidth>
          <LinearProgress />
        </Dialog>
      )}
    </>
  );
};

export default SMTPProfileMaster;
